import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6660e462")

_pushScopeId("data-v-6660e462")
const _hoisted_1 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_2 = { class: "flex flexR mar-t-22" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_el_table, {
      data: $setup.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": $setup.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", {
                class: "btn-red-line mar-l-8",
                onClick: ($event: any) => ($setup._upState(scope.row.id))
              }, _toDisplayString(scope.row.project_status == 0 ? '启动': '禁止'), 9, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, $setup.loading]
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        onSizeChange: $setup.handleSizeChange,
        onCurrentChange: $setup.handleCurrentChange,
        "current-page": $setup.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": $setup.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $setup.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ], 64))
})